module.exports = __webpack_public_path__ + "img/gb9456.prt.3c313dc8.jpg";